/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CodeAndLabelWithIndent,
    CodeAndLabelWithIndentFromJSON,
    CodeAndLabelWithIndentFromJSONTyped,
    CodeAndLabelWithIndentToJSON,
} from './';

/**
 * 
 * @export
 * @interface CountryFormConfiguration
 */
export interface CountryFormConfiguration {
    /**
     * 
     * @type {Array<CodeAndLabelWithIndent>}
     * @memberof CountryFormConfiguration
     */
    readonly regions?: Array<CodeAndLabelWithIndent> | null;
}

export function CountryFormConfigurationFromJSON(json: any): CountryFormConfiguration {
    return CountryFormConfigurationFromJSONTyped(json, false);
}

export function CountryFormConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CountryFormConfiguration {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'regions': !exists(json, 'regions') ? undefined : (json['regions'] === null ? null : (json['regions'] as Array<any>).map(CodeAndLabelWithIndentFromJSON)),
    };
}

export function CountryFormConfigurationToJSON(value?: CountryFormConfiguration | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}


